import React, { useState } from 'react'
import Fixtures from '../components/Public/FootballAPI/Fixture/Fixtures'
import SingleFixture from '../components/Public/FootballAPI/Fixture/SingleFixture'

function FixturesAPIPage() {

    const [show, setShow] = useState(false);

    return (
        <div className="bg-lightgrey">
            <div className="showResponsive">
                {show && <SingleFixture />}
                <Fixtures type="small" onClick={() => setShow(true)} />
            </div>
            <div className="container">
                <div className="row showLarge">
                    <div className="col-md-4">
                        <Fixtures />
                    </div>
                    <div className="col-8">
                        <SingleFixture />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FixturesAPIPage
